export default "__VITE_ASSET__Ceuw3$oZ__"